<template>
    <sa-page-layout :btnAnnullaVisible="true" :btnSaveVisible="true" :linkback="linkback" :data="jsonData" @aftersave="onAfterSave" :showModalLoading="showModalLoading" :pathResource="pathResource" class="sa-no-space">
        <template slot="table-body">
            <farmacie-edit-component ref="FarmacieEditComponent" :showModalLoading="showModalLoading" @update="onUpdateJsonData" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData"></farmacie-edit-component>
        </template>
    </sa-page-layout>
</template>
<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import FarmacieEditComponent from "../components/FarmacieEditComponent.vue";

export default {
    components: { SaPageLayout, FarmacieEditComponent },
    data() {
        return {
            showModalLoading: false,
            pathResource: "/farmacie",
            linkback: "/farmacie",
            jsonData: {},
            id: "-1",
        };
    },
    methods: {
        onUpdateJsonData(data) {
            let me = this;
            me.jsonData = data;
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onAfterSave() {
            console.log("after save");
        },
    },
};
</script>

<style></style>
